import styled, { css } from "styled-components";
import { CancelButton } from "@sonder/ui/source/styled/fragments/CancelButton";
import { Button } from "@sonder/ui/source/styled/primitives/Button";
import { sizes, zIndex } from "@sonder/ui/source/styled/theme";

const fullScreenStyles = css`
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${zIndex.imageSlide};
  background: #ffffffaa;

  ${CancelButton} {
    display: none;
  }
`;

interface ImageSlideProps {
  height?: string;
  fullScreen?: boolean;
  isPDF?: boolean;
}

const pseudoSelectorStyles = css<ImageSlideProps>`
  &:before {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const ImageSlide = styled(Button)<ImageSlideProps>`
  display: block;
  flex: 0 0 auto;
  height: ${props => props.height || sizes.imageHeightDefault};
  position: relative;
  ${props => props.fullScreen && fullScreenStyles}
  ${props => props.isPDF && !props.fullScreen && pseudoSelectorStyles}

  iframe {
    height: 90%;
    width: 90%;
  }
`;
